const zh = {
	'快跟我一起来<br />SuperChinese学中文吧!': '快跟我一起来<br />SuperChinese学中文吧!',
	'零基础任性学': '零基础任性学',
	'听说读写全面提升': '听说读写全面提升',
	'趣味对话': '趣味对话',
	'100+日常对话等你来': '100+日常对话等你来',
	'智能AI': '智能AI',
	'个性化学习推荐，由浅入深系统学': '个性化学习推荐，由浅入深系统学',
	'趣味对话等你来': '趣味对话等你来',
	'立即打开': '立即打开',
	'我在SuperChinese<br />已累计学习{day}天': '我在SuperChinese<br />已累计学习<span>{day}</span>天',
	'我在SuperChinese<br />已连续学习{day}天': '我在SuperChinese<br />已连续学习<span>{day}</span>天',
	'学习生词': '学习生词',
	'学习语法': '学习语法',
	'口语练习': '口语练习',
	'{n}个': '<span>{n}</span>个',
	'{n}次': '<span>{n}</span>个',
	'点击右上角的按钮,选择在浏览器中打开': '点击右上角的按钮,选择在浏览器中打开',
	'邀请码': '邀请码',
	'用邀请码注册，参与抽大奖': '邀请新用户注册并填写邀请码，即可参与抽大奖。',
}
export default zh;